import { semOcorrenciaInadimplenciaStyles } from './SemOcorrenciaInadimplencia.style'

export function semOcorrenciaInadimplenciaIO() {
  return {
    styles: semOcorrenciaInadimplenciaStyles
  }
}

export type SemOcorrenciaInadimplenciaIO = ReturnType<typeof semOcorrenciaInadimplenciaIO>
